module.exports = __webpack_public_path__ + "img/patyna.72b62333.jpg";